export const colors = [
  '#efefef',
  '#999999',
  '#e22828',
  '#f77f25',
  '#ffc814',
  '#04d372',
  '#00beff',
  '#0073ff',
  '#a641ff',
  '#d10070',
]

/**
 * Creates a Generator for getting one of the default bookmark colors, loops
 * over the list of colors in order indefinitely (leaves off the first two
 * colors on purpose since they are used for action item and bookmark)
 */
export function* bookmarkColorIterator() {
  let index = 0
  const autoColors = colors.slice(2)
  while (true) {
    yield autoColors[index++ % autoColors.length]
  }
}
